exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bolded[data-v-f03ed536]{font-weight:700}.error[data-v-f03ed536]{font-size:22px;color:rgba(0,0,0,.87);font-weight:400}.error[data-v-f03ed536],.reports h2[data-v-f03ed536]{margin:50px 0;text-align:center}.reports h2 span[data-v-f03ed536]{display:block}.reports h2 .lighter[data-v-f03ed536]{margin-top:15px;font-size:16px}.reports-table[data-v-f03ed536]{margin-top:75px}.reports-table[data-v-f03ed536]:last-of-type{margin-bottom:50px}.reports-table h3[data-v-f03ed536]{margin-left:20px}.reports-table .md-table-cell[data-v-f03ed536]:not(:first-of-type),.reports-table .md-table-head[data-v-f03ed536]:not(:first-of-type){text-align:right}.reports-table .subscription-type[data-v-f03ed536]{color:#000;font-weight:700;border-top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f03ed536","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Admin/Subscriptions/ReportsGeneral.vue
// module id = 447
// module chunks = 0